import React from 'react';
import styled from 'styled-components';
import Header from './components/Header';
import { themeColor } from '../Theming';
import {
  ANALYTICS_PAGE_NAMES,
  trackClickedActionEvent,
  useIsIPad,
} from '../Common/Analytics/utils';
import usePageViewTracking from '../Common/Hooks/usePageViewTracking';
import { isAndroid } from 'react-device-detect';
import { useHistory } from 'react-router-dom';
import { useQuery } from '../Common/Hooks';
import { Path } from '../Routing';

const Container = styled.div<{ isIPad?: boolean }>`
  display: flex;
  flex: 1;
  flex-direction: column;
  max-height: 100dvh;
  max-width: ${(props) => (props.isIPad ? '100%' : '600px')};
  margin: 0 auto;
`;

const MainContent = styled.div<{ isIPad?: boolean }>`
  padding: ${(props) =>
    props.isIPad ? '0px 100px 0 100px' : '32px 24px 0 24px'};
  & > p {
    font-size: ${(props) => (props.isIPad ? '28px' : '22px')};
    font-weight: 600;
    & > span {
      display: inline-block;
    }
  }
`;

const List = styled.ul<{ isIPad?: boolean }>`
  list-style: none;
  padding: 0;
  margin: 0;

  & > li {
    display: flex;
    align-items: center;
    margin-bottom: ${(props) => (props.isIPad ? '30px' : '20px')};
    font-size: ${(props) => (props.isIPad ? '24px' : '18px')};

    & > img {
      height: ${(props) => (props.isIPad ? '40px' : '30px')};
      width: ${(props) => (props.isIPad ? '40px' : '30px')};
      margin-right: ${(props) => (props.isIPad ? '20px' : '13px')};
    }
  }
`;

const Button = styled.button<{ isIPad?: boolean }>`
  background-color: #2d3c46;
  height: ${(props) => (props.isIPad ? '80px' : '61px')};
  flex: 1;
  color: ${themeColor('white')};
  font-size: ${(props) => (props.isIPad ? '24px' : '18px')};
  font-weight: 600;
  font-style: semi-bold;
`;

const BottomContent = styled.div<{ isIPad?: boolean }>`
  padding: ${(props) =>
    props.isIPad ? '0 100px 48px 100px' : '0 24px 32px 24px'};
  display: flex;
  justify-content: center;
  align-items: flex-end;
  flex: 1;
`;

const NTVActivation = () => {
  const { landing_page } = ANALYTICS_PAGE_NAMES;
  usePageViewTracking(landing_page, 'NTV');
  const history = useHistory();
  const query = useQuery();

  const isIPad = useIsIPad();

  const steps = [
    {
      text: 'Kostenlos und ohne Anmeldung',
      img: require('../Assets/NTV/check.png'),
    },
    {
      text: 'Für über 150.000 Shops und Marken',
      img: require('../Assets/NTV/cart.png'),
    },
    {
      text: 'Für nachhaltigen Konsum',
      img: require('../Assets/NTV/tree.png'),
    },
  ];

  const onActivateClick = () => {
    trackClickedActionEvent(query, 'NTV', 'activate', landing_page);
    if (isAndroid) {
      return history.push({
        pathname: Path.NTVPluginAndroidAccessibility,
        search: location.search,
      });
    }
    history.push({
      pathname: Path.NTVPluginActivationMultiStep,
      search: location.search,
    });
  };

  return (
    <Container isIPad={isIPad}>
      <Header showBrands logoWidth={77} text="ntv Shopping Deals" />
      <MainContent isIPad={isIPad}>
        <p>
          <span>Wir finden automatisch die besten Rabattcodes für Sie:</span>
        </p>
        <List isIPad={isIPad}>
          {steps.map((step, index) => (
            <li key={index}>
              <img src={step.img.default} alt={step.text} />
              {step.text}
            </li>
          ))}
        </List>
      </MainContent>
      <BottomContent isIPad={isIPad}>
        <Button isIPad={isIPad} onClick={onActivateClick}>
          Jetzt aktivieren
        </Button>
      </BottomContent>
    </Container>
  );
};

export default NTVActivation;
